import script from "./ModalPagoPendiente.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalPagoPendiente.vue?vue&type=script&setup=true&lang=js"

import "./ModalPagoPendiente.vue?vue&type=style&index=0&id=1858770e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1858770e"]])

export default __exports__